export default {
  GET_TASK_INDEX_REQUEST: '@@task-index-items/GET_TASK_INDEX_REQUEST',
  GET_TASK_INDEX_SUCCESS: '@@task-index-items/GET_TASK_INDEX_SUCCESS',
  GET_TASK_INDEX_ERROR: '@@task-index-items/GET_TASK_INDEX_ERROR',
};
